import { CurrencyFormatFunc } from '../../../formatters/CurrencyFormat';

export default function ProductSpecificationsData(minAge, maxAge, minCoverageAmount, maxCoverageAmount,paymenttypes) {
    minCoverageAmount = CurrencyFormatFunc(minCoverageAmount, true);
    maxCoverageAmount = CurrencyFormatFunc(maxCoverageAmount, true);
 return ([
        {
            title: "Issue ages",
            text: `${minAge}-${maxAge} years`,
        },
        {
            title: "Coverage amounts available",
            text: `<span>${minCoverageAmount}-${maxCoverageAmount}</span>`,
        },
        {
            title: "Many Payments types",
            text: ` <span>${paymenttypes}</span >`,
               
        },
    ])
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/perm/KeyFeaturesData.js